import React, { Suspense } from "react";
import { WithdrawState } from "../payments/PaymentsReducer";
import { UserInfo } from "../http/protocol";
import CoinpaymentsPaymentComponent from "../ui/paymentproviders/CoinpaymentsPaymentComponent";
import { TestPaymentComponent } from "../ui/paymentproviders/TestPaymentComponent";
import AgentPaymentComponent from "../ui/paymentproviders/AgentPaymentComponent";
import { PaymentLoading } from "./PaymentLoading";
import { GenericPaymentComponent } from "../ui/paymentproviders/GenericPaymentComponent";
import { SimplepayPaymentComponent } from "../ui/paymentproviders/SimplepayPaymentComponent";

const PaymentIQPaymentComponent = React.lazy(() => import("../ui/paymentproviders/PaymentIQPaymentComponent"));

interface WithdrawProviderSpecificProps {
  provider?: string;
  withdraw: WithdrawState;
  code?: string;
  user?: UserInfo;
  handleClickOk: () => void;
}

const WithdrawProviderSpecific = ({ withdraw, provider, code, handleClickOk, user }: WithdrawProviderSpecificProps) => {
  switch (provider) {
    case "test":
      return <TestPaymentComponent type={"withdraw"} withdraw={withdraw} handleClickOk={handleClickOk} />;
    case "simplepay":
      return <SimplepayPaymentComponent type={"withdraw"} />;
    case "coinpayments":
      return <CoinpaymentsPaymentComponent type={"withdraw"} withdraw={withdraw} handleClickOk={handleClickOk} code={code} />;
    case "agent":
      return <AgentPaymentComponent type={"withdraw"} withdraw={withdraw} handleClickOk={handleClickOk} />;
    case "paymentiq":
      return (
        <Suspense fallback={<PaymentLoading />}>
          <PaymentIQPaymentComponent type={"withdraw"} withdraw={withdraw} userUid={user?.userUid!} handleClickOk={handleClickOk} />
        </Suspense>
      );
    default:
      return <GenericPaymentComponent type={"withdraw"} withdraw={withdraw} handleClickOk={handleClickOk} />;
  }
};

export default WithdrawProviderSpecific;
